import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { format } from 'date-fns';
import {
  Button,
  Box,
  Collapse,
  Icon,
  IconButton,
  TableCell,
  TableRow
} from '@material-ui/core';
import { deleteFailedMarketingSegmentQueueTask } from 'api';
import { useStyles } from './styles';
import QuoteDetails from './QuoteDetails';


const QuotesQueueResultTableRow = ({task, tableCells}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [openRow, setOpenRow] = useState(false);

  const getCustomerData = () => {
    if (task?.akwaCustomer?.customerDetails || task?.akwaCustomer?.magentoDraftCustomer) {
      return task?.akwaCustomer?.customerDetails || task?.akwaCustomer?.magentoDraftCustomer || {};
    } else if (task?.customer) {
      return task?.customer || {};
    }

    return {};
  };

  const customer = getCustomerData();
  const {
    firstName = customer?.firstname || '',
    lastName = customer?.lastname || '',
    email = customer?.email || '',
    dob = customer?.dob || '',
    custom_attributes = customer?.custom_attributes || []
  } = customer;

  const { createdAt, createdBy, error } = task;

  const formatDate = (date, dateFormat = 'MM/dd/yyyy') => {
    return date ? format(new Date(date), dateFormat) : '';
  };

  const dobFormatted = formatDate(dob);
  const createdAtDate = new Date(createdAt);
  const createdAtFormatted = `${formatDate(createdAtDate)}\n${formatDate(createdAtDate, 'hh:mm:ss aa')}`;

  const phoneNumber = task?.akwaCustomer?.customerDetails
    ? customer?.phone || ''
    : custom_attributes?.find((attr) => attr.attribute_code === 'phone_number')?.value || '';

  const columns = tableCells.reduce((acc, column) => {
    acc[column.label] = column;
    return acc;
  }, {});

  const handleDeleteFromQueue = (id) => {
    deleteFailedMarketingSegmentQueueTask({dispatch, id});
  };

  return (
    <>
      <TableRow>
        {columns['First Name']?.display && <TableCell>{firstName}</TableCell>}
        {columns['Last Name']?.display && <TableCell>{lastName}</TableCell>}
        {columns['Email']?.display && <TableCell>{email}</TableCell>}
        {columns['Phone Number']?.display && <TableCell width="120px">{phoneNumber}</TableCell>}
        {columns['DOB']?.display && <TableCell width="100px">{dobFormatted}</TableCell>}
        {columns['Created At']?.display && <TableCell width="100px">{createdAtFormatted}</TableCell>}
        {columns['Created By']?.display && <TableCell>{createdBy}</TableCell>}
        {columns['Error']?.display &&
          <TableCell width="200px">
            <div
              title={error?.message || ''}
              className="text-error"
            >
              {error?.message || ''}
            </div>
          </TableCell>
        }
        {columns['Action']?.display &&
          <TableCell align="center" width="100px">
            <IconButton
              size="small"
              onClick={() => handleDeleteFromQueue(task._id)}
              title="Remove from queue"
            >
              <Icon fontSize="small">delete</Icon>
            </IconButton>
          </TableCell>}
        <TableCell align="left">
          <Button
            className="p-0 whitespace-no-wrap text-13"
            color="primary"
            onClick={() => setOpenRow((isOpen) => !isOpen)}
          >
            <Icon className="mr-1" fontSize="small">
              {`${openRow ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}`}
            </Icon>
            {'Quote Details'}
          </Button>
        </TableCell>
      </TableRow>
      <TableRow className={classes.bgBlue}>
        <TableCell colSpan={10} className="p-0 border-none">
          <Collapse in={openRow} timeout="auto" unmountOnExit>
            <Box className="py-3">
              <QuoteDetails task={task} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default QuotesQueueResultTableRow;
